import { withDependencies } from '@wix/thunderbolt-ioc'
import { ILogger, IComponentStructureFixer, LoggerSymbol } from '@wix/thunderbolt-symbols'
import type { Component } from '@wix/thunderbolt-becky-types'

class MissingComponentTypeError extends Error {
	constructor() {
		super('componentType is missing in structure')
		this.name = 'MissingComponentTypeError'
	}
}

class MissingComponentTypeInMasterPageError extends Error {
	constructor() {
		super('masterPage is missing componentType in structure')
		this.name = 'MissingComponentTypeInMasterPageError'
	}
}

const errorTags = { feature: 'viewerManagerStructureApi', methodName: 'updateStructure' }

function fixComponentTypeAndReport(currentComp: Component | undefined, compStructure: Component, logger: ILogger) {
	const fallbackCompType = currentComp?.componentType ?? 'DivWithChildren'
	const errorOptions = {
		tags: { ...errorTags, fallbackCompType },
		extra: { compStructure: { ...compStructure } },
	}

	const error =
		compStructure.id === 'masterPage'
			? new MissingComponentTypeInMasterPageError()
			: new MissingComponentTypeError()
	logger.captureError(error, errorOptions)

	compStructure.componentType = fallbackCompType
}

export const ComponentStructureFixer = withDependencies(
	[LoggerSymbol],
	(logger: ILogger): IComponentStructureFixer => ({
		fixStructureAndReport: (currentStructure: Component | undefined, newStructure: Component) => {
			if (!newStructure.componentType) {
				fixComponentTypeAndReport(currentStructure, newStructure, logger)
			}
		},
	})
)
